import { render } from "./StatusDropdown.vue?vue&type=template&id=30ce051e"
import script from "./StatusDropdown.vue?vue&type=script&lang=js"
export * from "./StatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__